var _excluded = ["className", "mask", "onMask", "onInput", "helpText", "placeholder", "value", "censor", "onFocus", "onBlur", "onKeyDown", "onValidChange", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import FormField from '../form-field';
import combineRefs from '../../utilities/combine-refs';
var propTypes = {
  /**
   * provided mask format to mask the input's value
   */
  mask: PropTypes.string.isRequired,
  /**
   * The provided value for the masked input;
   * this would be provided by a parent component.
   */
  value: PropTypes.string,
  /**
   * helpText displayed Expected format
   */
  helpText: PropTypes.node,
  /**
   * The placeholder for the masked input.
   */
  placeholder: PropTypes.string,
  /**
   * onChange callback.
   */
  onChange: PropTypes.func,
  /**
   * onValidChange callback.
   */
  onValidChange: PropTypes.func,
  /**
   * onMask callback.
   */
  onMask: PropTypes.func,
  /**
   * onBlur callback.
   */
  onBlur: PropTypes.func,
  /**
   * onFocus callback.
   */
  onFocus: PropTypes.func,
  /**
   * onInput callback.
   */
  onInput: PropTypes.func,
  /**
   * onKeyDown callback.
   */
  onKeyDown: PropTypes.func,
  /**
   * className modifier/addition.
   */
  className: PropTypes.string,
  /**
   * censor string marking obfuscated characters. String will need to match the mask pattern.
   * e.g. { mask: "00-00-0000", censor: "00-00-****" }
   */
  censor: PropTypes.string,
  /** Add utility objects for styling */
  utils: PropTypes.object
};

/**
 * Defines the default props for the masked input.
 */
var defaultProps = {
  value: null,
  placeholder: '',
  onValidChange: function onValidChange(event) {},
  onChange: function onChange(event) {},
  onInput: function onInput(event) {},
  onFocus: function onFocus(event) {},
  onBlur: function onBlur(event) {},
  onKeyDown: function onKeyDown(event) {},
  onMask: function onMask(details) {},
  className: '',
  helpText: '',
  censor: '',
  utils: {}
};

/**
 * The patterns used by the masked input.
 */
var PATTERNS = {
  A: /[A-Z*]/,
  a: /[a-z*]/,
  x: /[A-Za-z*]/,
  0: /[0-9*]/,
  '*': /[A-Za-z0-9*]/
};

/**
 * Accepts a value
 * and return a censored value in the pattern provided
 */
var getCensor = function getCensor(cv, curCensor) {
  return cv.split('').map(function (_char, i) {
    return curCensor[i] === '*' ? curCensor[i] : _char;
  }).join('');
};

/**
 * Accepts a value and a mask return
 * a value masked in the provided form (mask)
 */
var getMask = function getMask(val, curMask) {
  if (!val || !curMask) {
    return '';
  }
  var validChars = [];
  var maskLength = curMask.length;
  var valueLength = val.length;
  var mi = 0;
  var vi = 0;
  while (mi < maskLength && vi < valueLength) {
    var maskChar = curMask.charAt(mi);
    var valChar = val.charAt(vi);
    var pattern = PATTERNS[maskChar];
    if (pattern) {
      if (valChar.match(pattern)) {
        validChars.push(valChar);
        mi += 1;
      }
      vi += 1;
    } else {
      validChars.push(maskChar);
      if (maskChar === valChar) {
        vi += 1;
      }
      mi += 1;
    }
  }
  return validChars.join('');
};

/**
 * Returns the cursor offset needed
 */
var getSeparatorsOffset = function getSeparatorsOffset(cursorPos, val) {
  var currentCursorPosition = cursorPos;
  var _char2 = val.charAt(currentCursorPosition);
  var separatorsOffset = 0;
  while (isCharSeparator(_char2)) {
    currentCursorPosition += 1;
    _char2 = val.charAt(currentCursorPosition);
    separatorsOffset += 1;
  }
  return separatorsOffset;
};

/**
 * Returns the cursor offset needed
 * to account the the mask separators.
 */
var getNewCursorPosition = function getNewCursorPosition(cursorPos, val, maskedVal, prevMaskedValue) {
  // if we're working with the same value or the input only have 1 digit, return early
  if (maskedVal === prevMaskedValue || maskedVal.length < prevMaskedValue.length && val.length !== 1) {
    return cursorPos;
  }
  var separatorsOffset = getSeparatorsOffset(cursorPos - 1, maskedVal);
  return cursorPos + separatorsOffset;
};

/**
 * Returns a boolean that determines
 * whether or not that provided character
 * is a separator.
 */
var isCharSeparator = function isCharSeparator(_char3) {
  if (!_char3) {
    return false;
  }
  return Object.keys(PATTERNS).filter(function (key) {
    var pattern = PATTERNS[key];
    return _char3.match(pattern);
  }).length === 0;
};

/**
 * Returns a pure value with no separators
 */
var getPureValue = function getPureValue(val) {
  /* Create array of characters and trim whitespace */
  var charArr = val.split('').filter(function (item) {
    return item.trim() !== '';
  });
  for (var i = 0; i < val.length; i += 1) {
    var isSeparator = isCharSeparator(charArr[i]);
    if (isSeparator) {
      charArr.splice(i, 1);
    }
  }
  return charArr.join('');
};

/**
 * @ignore @description
 * ## Masked Form Field
 * Add custom masking to form fields to force the user to type the correct format.
 *
 * @ignore @see Mesh: [Masked Form Field Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/forms-maskedformfield--default)
 *
 * @ignore @example
 * ```jsx
 * import { MaskedFormField } from 'mesh-component-library';
 *
 *  <MaskedFormField
 *    id="form-field-1"
 *    value="2323232323"
 *    label="Phone Number"
 *    required
 *    placeholder="630-458-1900"
 *    onMask={details => {
 *     console.log(details);
 *    }}
 *    helpText="Expected format: 000-000-0000"
 *    mask="000-000-0000"
 *  />;
 * ```
 */

var MaskedFormField = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var className = props.className,
    mask = props.mask,
    onMask = props.onMask,
    onInput = props.onInput,
    helpText = props.helpText,
    placeholder = props.placeholder,
    value = props.value,
    censor = props.censor,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    onValidChange = props.onValidChange,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    cursorPosition = _useState2[0],
    setCursorPosition = _useState2[1];
  var _useState3 = useState(value || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    stateValue = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = useState(getMask(value, mask)),
    _useState6 = _slicedToArray(_useState5, 2),
    _prevMaskedValue = _useState6[0],
    setPrevMaskedValue = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasFocus = _useState8[0],
    setHasFocus = _useState8[1];
  var onRefSet = useCallback(function (formField) {
    if (!formField) {
      return;
    }
    // if the formField contains focus, set its cursor position
    if (formField === document.activeElement) {
      setTimeout(function () {
        formField.setSelectionRange(cursorPosition, cursorPosition);
      });
    }
  }, [stateValue]);
  useEffect(function () {
    var val = value === null ? '' : value;
    var maskedVal = getMask(val, mask);
    setValue(maskedVal);
    setPrevMaskedValue(maskedVal);
  }, [mask, value]);

  /**
   * Handle the input's input event;
   * change the cursorPosition and mask the value;
   */
  var onInputHandler = function onInputHandler(event) {
    var target = event.target;
    var newValue = target.value;
    var prevMaskedValue = target.defaultValue;
    var cursorPos = target.selectionStart;
    var newMaskedValue = getMask(newValue, mask);
    var newCursorPosition = getNewCursorPosition(cursorPos, newValue, newMaskedValue, _prevMaskedValue);
    if (prevMaskedValue != newMaskedValue) {
      onValidChange(event);
    }
    setValue(newMaskedValue);
    setPrevMaskedValue(newMaskedValue);
    setCursorPosition(newCursorPosition);
    onInput(event);
    onMask({
      value: newMaskedValue,
      pureValue: getPureValue(newMaskedValue)
    });
  };

  /**
   * Handle the input's blur event;
   */
  var onBlurHandler = function onBlurHandler(event) {
    setHasFocus(false);
    onBlur(event, {
      value: stateValue,
      pureValue: getPureValue(stateValue)
    });
  };

  /**
   * Handle the input's focus event and send state
   * update the cursorPosition
   */
  var onFocusHandler = function onFocusHandler(event) {
    setHasFocus(true);
    onFocus(event, {
      value: stateValue,
      pureValue: getPureValue(stateValue)
    });
  };

  /**
   * Handle the input's on key down event
   * restrict the character input of 'asterisk'
   */

  var onKeyDownHandler = function onKeyDownHandler(event) {
    if (event.key === '*') {
      event.preventDefault();
    }
    onKeyDown(event, {
      value: stateValue,
      pureValue: getPureValue(stateValue)
    });
  };
  return /*#__PURE__*/React.createElement(FormField, _extends({
    className: className
  }, other, {
    helpText: helpText,
    placeholder: placeholder,
    ref: combineRefs(onRefSet, forwardedRef),
    value: !censor || hasFocus ? stateValue : getCensor(stateValue, censor),
    onInput: onInputHandler,
    onFocus: onFocusHandler,
    onBlur: onBlurHandler,
    onKeyDown: onKeyDownHandler,
    isMaskedInput: true,
    utils: utils
  }));
});
MaskedFormField.defaultProps = defaultProps;
MaskedFormField.displayName = 'MaskedFormField';
MaskedFormField.propTypes = propTypes;
export default MaskedFormField;